import { Tabs } from 'antd';
import React, { FC } from 'react';
import LicenseListPage from './license-list';
import StructmasterLicenseListPage from './structmaster-licenses/structmaster-license-list';
import { useTranslation } from 'react-i18next';

const LicenseListIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Tabs type="card">
      <Tabs.TabPane key={1} tab={t('Licenses')}>
        <LicenseListPage />
      </Tabs.TabPane>
      <Tabs.TabPane destroyInactiveTabPane key={2} tab={t('StructmasterLicenses')}>
        <StructmasterLicenseListPage />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default LicenseListIndex;
